import { range } from 'ramda';

export const PAYMENT_STRATEGIES = {
  PERSON: 'person',
  COUPLE: 'couple',
  GROUP: 'for_group',
  FAMILY: 'family',
  TRIP: 'safari',
};
export const PAYMENT_STRATEGY_OPTIONS = [
  {
    value: PAYMENT_STRATEGIES.PERSON,
    label: 'Per Person',
  },
  {
    value: PAYMENT_STRATEGIES.COUPLE,
    label: 'Per Couple',
  },
  {
    value: PAYMENT_STRATEGIES.GROUP,
    label: 'Per Group',
  },
  {
    value: PAYMENT_STRATEGIES.FAMILY,
    label: 'Per Family',
  },
  {
    value: PAYMENT_STRATEGIES.TRIP,
    label: 'Per Trip',
  },
];

export const DAY_COUNTING_STRATEGIES = {
  DAYS: 'days',
  NIGHTS: 'nights',
};
export const DAY_COUNTING_STRATEGY_OPTIONS = [
  {
    value: DAY_COUNTING_STRATEGIES.DAYS,
    label: 'Days',
  },
  {
    value: DAY_COUNTING_STRATEGIES.NIGHTS,
    label: 'Nights',
  },
];

export const ROOMING_TYPES = {
  SHARED: 'shared',
  SINGLE: 'single',
  MIXED: 'mixed',
  EXCLUSIVE: 'exclusive',
};
export const ROOMING_TYPE_OPTIONS = [
  {
    value: ROOMING_TYPES.SHARED,
    label: 'Shared',
  },
  {
    value: ROOMING_TYPES.SINGLE,
    label: 'Single',
  },
  {
    value: ROOMING_TYPES.MIXED,
    label: 'Mixed',
  },
  {
    value: ROOMING_TYPES.EXCLUSIVE,
    label: 'Exclusive use',
  },
];

export const CURRENCY_TYPES = {
  USD: 'usd',
  EURO: 'eur',
  POUND: 'gbp',
  RAND: 'zar',
};

export const NUMBER_OPTIONS = range(1, 101).map((number) => ({ label: `${number}`, value: number }));
